import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotArticles from './components/HotArticles';
import CategoryNav from './components/CategoryNav';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';
import { useJsonLd } from '@/hooks/useJsonLd';

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "51吃瓜黑料是什么网站？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51吃瓜黑料是国内领先的娱乐资讯聚合平台，专注于为吃瓜群众提供最快、最全、最真实的网红塌房、明星爆料、博主反差等热点内容，覆盖网曝门、每日大赛现场等多元化吃瓜资源。"
      }
    },
    {
      "@type": "Question",
      "name": "如何在线观看51吃瓜黑料视频？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "访问51吃瓜黑料网址入口，在视频入口分类下即可在线观看高清吃瓜视频。网站支持多清晰度切换，无需下载任何APP，直接通过浏览器即可流畅观看。"
      }
    },
    {
      "@type": "Question",
      "name": "51吃瓜黑料更新频率如何？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51吃瓜黑料实行7×24小时不打烊更新机制，编辑团队全天候监控各大社交平台、直播平台的最新动态，确保第一时间发布最新爆料内容，平均更新速度快于同类平台。"
      }
    },
    {
      "@type": "Question",
      "name": "51吃瓜黑料的内容可信吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "51吃瓜黑料坚持真实、客观的报道原则，所有爆料内容均经过编辑团队多方核实。网站已累计报道超过10万条爆料事件，拥有百万级日均活跃用户，是中文互联网最具影响力的吃瓜资讯平台之一。"
      }
    },
    {
      "@type": "Question",
      "name": "如何联系51吃瓜黑料进行投稿或申诉？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以通过关于我们页面的联系方式（邮箱：hello@ahyuntong.cn，电话：400-888-8888）进行爆料投稿或侵权申诉，我们将在24小时内回复您的诉求。"
      }
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "51吃瓜黑料 | 51吃瓜黑料在线观看与视频入口 | 网曝门爆料不打烊",
  "description": "51吃瓜黑料集结全网热门的网红塌房黑料与每日大赛现场，提供51吃瓜黑料在线观看与视频入口。覆盖网曝门、明星爆料、博主反差记录，网站不打烊更新。",
  "url": "http://ahyuntong.cn/",
  "inLanguage": "zh-CN",
  "isPartOf": {
    "@type": "WebSite",
    "name": "51吃瓜黑料",
    "url": "http://ahyuntong.cn/"
  }
};

export default function Home() {
  useJsonLd(faqSchema);
  useJsonLd(webPageSchema);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotArticles />
        <CategoryNav />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}